import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Gauge, Globe, Users } from 'lucide-react';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: <Shield size={32} />,
      title: 'Enterprise Security',
      description: 'Bank-grade security with end-to-end encryption and compliance certifications.'
    },
    {
      icon: <Gauge size={32} />,
      title: 'High Performance',
      description: 'Optimized infrastructure delivering sub-millisecond response times at scale.'
    },
    {
      icon: <Globe size={32} />,
      title: 'Global Reach',
      description: 'Multi-region deployment with edge computing for worldwide accessibility.'
    },
    {
      icon: <Users size={32} />,
      title: '24/7 Support',
      description: 'Dedicated support team with expert engineers available around the clock.'
    }
  ];

  return (
    <section id="features" className="features section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="features-content"
        >
          <div className="features-text">
            <h2 className="features-title">
              Why Choose <span className="gradient-text">RiftCo</span>?
            </h2>
            <p className="features-description">
              We deliver cutting-edge solutions with unmatched reliability, 
              performance, and support to power your business forward.
            </p>
          </div>
          
          <div className="features-grid">
            {features.map((feature, index) => (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="feature-item"
              >
                <div className="feature-icon">
                  {feature.icon}
                </div>
                <div className="feature-content">
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Features;
